import { Flex, Link, Text } from '@chakra-ui/react';
import { formatAbbr } from '~/utils';

import { PLATFORM_FOLOWERS_ICON_COMPONENT } from './PlatformFollowersLabel.constants';
import { Platform } from './PlatformFollowersLabel.types';

interface Props {
  platform: Platform;
  href: string;
}

export const PlatformFollowersLabel: React.FC<Props> = ({ platform, href }) => {
  const PlatformIconComponent = PLATFORM_FOLOWERS_ICON_COMPONENT[platform.name];

  return (
    <Flex
      key={platform.name}
      data-testid={`${platform.name}-section`}
      alignItems="center"
      gap={2}
    >
      <Link href={href} isExternal rel="noopener noreferrer">
        <PlatformIconComponent
          aria-label={platform.name}
          boxSize={5}
          verticalAlign="text-top"
        />
      </Link>
      <Text
        as="span"
        fontSize="md"
        color="primary.700"
        fontWeight="medium"
        lineHeight={{
          base: '19.3px',
          md: '14.16px',
        }}
      >
        {formatAbbr(platform.followers)}
      </Text>
    </Flex>
  );
};
